import React, { useEffect, useState, useRef } from 'react';

const DateTimeStamp = ({ realTimeData }) => {
  const [currentTimestamp, setCurrentTimestamp] = useState(null);
  const [warningMessage, setWarningMessage] = useState("");
  const timestampRef = useRef(null); 


  // Keep the ref in sync with state
  useEffect(() => {
    if (currentTimestamp) {
      timestampRef.current = currentTimestamp;
    }
  }, [currentTimestamp]);

  // Update timeStamp whenever realTimeData changes
  useEffect(() => {
    if (realTimeData) {
      setCurrentTimestamp(realTimeData.timeStamp.toDate());
    }
  }, [realTimeData]);

  // runs every 5 secs on redner
  useEffect(() => {
    const checkForWarning = () => {
      if (!timestampRef.current) return; 

      const now = new Date();
      const compDate = new Date(timestampRef.current);
      const diff = now - compDate;

      console.log("Now:", now);
      console.log("Comp Date:", compDate);
      console.log("Diff:", diff);

      if (diff > 120000) {
        setWarningMessage("⚠️ Data is outdated! Please reboot system or call your SarTec representative.");
      } else {
        setWarningMessage("");
      }
    };

    const intervalId = setInterval(checkForWarning, 5000);
    return () => clearInterval(intervalId);
  }, []); 

  return (
    <div className="grid grid-cols-1 lg:col-span-4 bg-slate-400 p-4 rounded-lg shadow-3xl">
      <div className="bg-slate-100 lg:text-xl font-bold p-4 rounded-lg text-center text-gray-700 shadow-3xl">
        {currentTimestamp && (
          <span>
            Data Timestamp: {new Date(currentTimestamp).toLocaleTimeString()} {warningMessage}
          </span>
        )}
      </div>
    </div>
  );
};

export default DateTimeStamp;
